<div class="pagination-container">
  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 100]"
    [pageIndex]="pageNumber"
    (page)="getAllEvent($event.pageIndex)">
  </mat-paginator>
</div>
